import { create } from 'zustand';

export const useCommandPalette = create<{
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  toggle: () => void;
}>((set) => ({
  isOpen: false,
  setIsOpen: (open) => set({ isOpen: open }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
}));
